import React from "react"
import { Container, Row, Col } from "reactstrap"
import { useState } from "react"
import PaymentSchedulesListHeader from "./PaymentSchedulesListHeader"
import PaymentSchedulesList from "./PaymentSchedulesList"
import ListingTabs from "../../Material/ListingTabs"
import ReportsPanel from "../../Reports/ReportsPanel"
import { usePresetFilters } from "../../Filters/presetFilters"

// Editable, visible default: the list opens showing scheduled payments; the user
// can change the statuses or drop the preset entirely from the popover/chips.
const SCHEDULED_STATUS_PRESET = [
    { fieldName: "status", filterType: "in", filterValues: ["Scheduled"], editable: true, visible: true },
]

// No URL hash routing here -- this page never had tabs before, so there is
// nothing to preserve deep links for. Local state is enough.
const PAYMENT_SCHEDULE_LISTING_TABS = [
    { id: "#all", name: "Scheduled Payments" },
    { id: "#reports", name: "Activity Log", iconClassName: "fa fa-history", floatRight: true, iconOnly: true },
]

const PaymentSchedulesListContainer = (props) => {
    const [filterValues, setFilterValues] = useState({
        orderBy: ["-id"]
    })
    const [presets, setPresets, defaultPresets] = usePresetFilters(SCHEDULED_STATUS_PRESET)
    const [activeTab, setActiveTab] = useState(PAYMENT_SCHEDULE_LISTING_TABS[0].id)

    const updateOrder = (string) => {
        let order = [...filterValues.orderBy]
        if (!order.includes(string) && !order.includes("-" + string)) {
            order = [order.find(item => item.includes("-in_office")), string]
        } else {
            let index = order.indexOf(string)
            if (order.indexOf(string) > -1) {
                order[index] = "-" + string
            } else {
                index = order.indexOf("-" + string)
                index > -1 && (order[index] = string)
            }
        }
        setFilterValues({ ...filterValues, orderBy: order })
    }

    return (
        <Container fluid className="bos-listing-container">
            <ListingTabs
                tabs={PAYMENT_SCHEDULE_LISTING_TABS}
                activeTab={activeTab}
                onChange={setActiveTab}
            />
            {activeTab !== "#reports" && <PaymentSchedulesListHeader
                filterValues={filterValues}
                setFilterValues={(filterValues) => setFilterValues({ ...filterValues })}
                presets={presets}
                setPresets={setPresets}
                defaultPresets={defaultPresets}
            />}
            <Row>
                <Col>
                    {activeTab === "#reports" ?
                        <ReportsPanel reportId="scheduled_payments" />
                        :
                        <PaymentSchedulesList
                            key={String("true")}
                            updateOrder={updateOrder}
                            drvierId={filterValues && filterValues.driverId ? filterValues.driverId : null}
                            orderBy={filterValues && filterValues.orderBy ? filterValues.orderBy : []}
                            searchTerm={filterValues && filterValues.searchTerm ? filterValues.searchTerm : null}
                            presets={presets}
                            currentUser={props.currentUser}
                            history={props.navigate}
                            location={props.location}
                        />}

                </Col>
            </Row>
        </Container>

    )
}


export default PaymentSchedulesListContainer